var _defs, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetDOuter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "uuid-38866212-f08a-401d-b658-151c4167afaf",
    "data-name": "uuid-27562bad-bca1-4bd6-8175-f42bd1c75afa",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-cdcee441-1d26-44b9-89a6-6d172851c0e1 {\n        fill: #876233;\n      }\n\n      .uuid-bb5d4626-88d1-42d7-81ec-04e724582ab8 {\n        fill: #b87647;\n      }\n\n      .uuid-2bf9b98e-8f55-4961-83d9-b6974e2f8330 {\n        fill: #f2dab5;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-cdcee441-1d26-44b9-89a6-6d172851c0e1",
    y: 37.7,
    width: 80,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-bb5d4626-88d1-42d7-81ec-04e724582ab8",
    y: 0,
    width: 80,
    height: 37.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2bf9b98e-8f55-4961-83d9-b6974e2f8330",
    y: 39.7,
    width: 80,
    height: 68.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetDOuter);
export default __webpack_public_path__ + "static/media/PetDOuter.119556458029c78b104fc80482f5183c.svg";
export { ForwardRef as ReactComponent };